'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPlaceQuery = exports.selectInputSelection = exports.selectInputLocation = exports.setPlaceQuery = exports.setInputSelection = exports.setInputLocation = exports.resetLocationInput = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.reducer = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESET_LOCATION_INPUT = 'classpass/LocationInput/RESET_LOCATION_INPUT';
var SET_INPUT_LOCATION = 'classpass/LocationInput/SET_INPUT_LOCATION';
var SET_INPUT_SELECTION = 'classpass/LocationInput/SET_INPUT_SELECTION';
var SET_PLACE_QUERY = 'classpass/LocationInput/SET_PLACE_QUERY';

var resetLocationInput = exports.resetLocationInput = function resetLocationInput() {
  return { type: RESET_LOCATION_INPUT, data: { key: 'selection', value: null } };
};
var setInputLocation = exports.setInputLocation = function setInputLocation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      lat = _ref.lat,
      lon = _ref.lon,
      name = _ref.name;

  return { type: SET_INPUT_LOCATION, data: { key: 'location', value: { lat: lat, lon: lon, name: name } } };
};
var setInputSelection = exports.setInputSelection = function setInputSelection(selection) {
  return { type: SET_INPUT_SELECTION, data: { key: 'selection', value: selection } };
};
var setPlaceQuery = exports.setPlaceQuery = function setPlaceQuery(query) {
  return { type: SET_PLACE_QUERY, data: { key: 'query', value: query } };
};

var selectInputLocation = exports.selectInputLocation = function selectInputLocation(state) {
  return state.features.locationInput.location;
};
var selectInputSelection = exports.selectInputSelection = function selectInputSelection(state) {
  return state.features.locationInput.selection;
};
var selectPlaceQuery = exports.selectPlaceQuery = function selectPlaceQuery(state) {
  return state.features.locationInput.query;
};

var initialState = {
  location: null,
  query: '',
  selection: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_INPUT_LOCATION:
    case SET_INPUT_SELECTION:
    case SET_PLACE_QUERY:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.data.key, action.data.value));
    case RESET_LOCATION_INPUT:
      return initialState;
    default:
      return state;
  }
}